'use strict';

var module = angular.module('doclr.components.agenda', [
    'ui.router',
    'doclr.components.util',
    'doclr.resources.api'
]);

module.run(function() {
    /* Dutch (UTF-8) initialisation for the jQuery UI date picker plugin. */
    jQuery(function($) {
        $.datepicker.regional.nl = {
            closeText: 'Sluiten',
            currentText: 'Vandaag',
            monthNames: ['januari', 'februari', 'maart', 'april', 'mei', 'juni',
                'juli', 'augustus', 'september', 'oktober', 'november', 'december'],
            monthNamesShort: ['jan', 'feb', 'maa', 'apr', 'mei', 'jun',
                'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
            dayNames: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'],
            dayNamesShort: ['zon', 'maa', 'din', 'woe', 'don', 'vri', 'zat'],
            dayNamesMin: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
            weekHeader: 'Wk',
            isRTL: false,
            showMonthAfterYear: false,
            yearSuffix: ''
        };

        setDefaults($.datepicker.regional.uk);
        setDefaults($.datepicker.regional.nl);
        setDefaults($.datepicker.regional.en);
        setDefaults($.datepicker.regional.de);
        setDefaults($.datepicker.regional.fr);

        $.datepicker.setDefaults($.datepicker.regional.nl);



        function setDefaults(settings){
            if(!settings){
                return;
            }
            settings.dateFormat= 'yy-mm-dd';
            settings.firstDay= 1;
            settings.prevText = '<i class="glyphicon glyphicon-chevron-left"></i>';
            settings.nextText = '<i class="glyphicon glyphicon-chevron-right datepicker-button-forward"></i>';
        }



    });
});
